<div id="cont">
  <div>
    <span translate>You are here because you followed the Backup Agent Setup link.</span>
  </div>
  <div *ngIf="backupSetupInProgress || privyGetInfoInProgress" id="privy-cont">
    <span class="loading-info">
      <mat-spinner diameter="16"></mat-spinner>
      <span translate *ngIf="backupSetupInProgress">Sending data, please wait...</span>
      <span translate *ngIf="privyGetInfoInProgress">Requesting Backup Agent info, please wait...</span>
    </span>
  </div>
  <div *ngIf="!backupSetupInProgress && !privyGetInfoInProgress" id="privy-cont">
    <ng-container *ngIf="!roomId">
      <mat-icon>backup</mat-icon>
      <span translate>ViveSec Backup Agent can help you keep your data up to date.</span>
      <div>
        <button (click)="startBackup()" mat-flat-button color="primary">Start Synchronization Setup.</button>
      </div>
    </ng-container>
    <ng-container *ngIf="roomId">
      <mat-icon color="primary">check_circle</mat-icon>
      <span translate>ViveSec Backup Agent synchronization completed.</span>
      <span *ngIf="privyInfo">
        <span translate>Device name: </span>
        <span class="primary">{{privyInfo.name}}</span>
      </span>
      <div>
        <button [disabled]="quickSetupStarted || !privyInfo" (click)="quickSetup()" mat-flat-button color="primary" translate>Quick Setup</button>
      </div>

      <mat-divider></mat-divider>
      <span translate>Set up your backup via ViveSec Server Manager for this agent.</span>
      <div>
        <button (click)="openNanoManagerDialog()" mat-flat-button color="primary" translate>Open ViveSec Server Manager</button>
      </div>
      <ol>
        <li><span translate>Open ViveSec Server Manager</span></li>
        <li><span translate>Choose ViveSec</span></li>
        <li><span translate>Select a drive</span></li>
        <li><span translate>Open backup settings</span></li>
        <li><span translate>Select your Agent</span></li>
      </ol>
    </ng-container>
  </div>
</div>
